import styled, { css } from 'styled-components';

import { MediaQueries } from 'environment';
import { SpacingOffsets } from 'types/index';
import { generateSpacingOffsets } from 'helpers/cssGenerators';

export const Row = styled.div<SpacingOffsets>`
	${({ paddingOffset, marginOffset }) => css`
		display: flex;
		width: 100%;

		/* SPACING OFFSETS */
		${generateSpacingOffsets({ paddingOffset, marginOffset })}

		@media ${MediaQueries.maxWidth.sm} {
			flex-direction: column;
		}
	`}
`;

export const RowElement = styled.div`
	flex: 1;
`;
